import React, {Component} from 'react';

import {Modal,Button,ButtonToolbar} from 'react-bootstrap'
import FontAwesome from 'react-fontawesome'

class ConfirmPopup extends Component {
    onHide(){
     
    }


    renderConfirmButton(){
      let {confirmTitle,cancelTitle,hideBtn,onConfirm} = this.props
      let title  = (confirmTitle!==undefined)?confirmTitle:'ยืนยันการทำรายการ'
      let cTitle  = (cancelTitle!==undefined)?cancelTitle:'ยกเลิก'
      let display = (onConfirm!==undefined)?'block':'none'
      let displayHide = hideBtn?'block':'none'
      return (
          <ButtonToolbar className='pull-right'>
            <Button onClick={this.props.onConfirm} bsStyle='primary' style={{minWidth:'80px',display:display}}><FontAwesome name='thumbs-o-up'/>&nbsp;{title}</Button>
            {this.props.renderOptionBtn!==undefined?this.props.renderOptionBtn():''}
            <Button onClick={this.props.onHide}  style={{minWidth:'80px',display:displayHide}}><FontAwesome name='close'/>&nbsp;{cTitle}</Button>
          </ButtonToolbar>)
    }

    render(){
      
      let {show,title,message,renderEle,minHeight} = this.props
      let titleHeader  = (title!==undefined)?title:'ยืนยันการทำรายการ'
      return (
        <Modal style={{zIndex:this.props.zIndex}} show={show} onHide={this.props.onHide} dialogClassName="alert-popup-dialog">
          <Modal.Header>
            {titleHeader}
          </Modal.Header>
          <Modal.Body>
            <div style={{minHeight:minHeight}}>{message}</div>
            {renderEle!==undefined
            ?
            renderEle()
            :''}
          </Modal.Body>
          <Modal.Footer>
            {this.renderConfirmButton()}
          </Modal.Footer>
        </Modal>
      )
    }
}


ConfirmPopup.defaultProps = {
  title:'ยืนยันการทำรายการ',  
  confirmTitle:'ยืนยันการทำรายการ',
  cancelTitle:'ยกเลิก',
  message:'',  
  zIndex:'1050',
  hideBtn:true,
  minHeight:'50px'
}

export default ConfirmPopup



// WEBPACK FOOTER //
// ./src/component/element/ConfirmPopup.js